<script>
export default {
  props: ["clr"]
};
</script>
<template>
  <svg
    id="Arrow.16"
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
  >
    <g id="Group_864" data-name="Group 864" transform="translate(5 7)">
      <path
        id="Path_8191"
        data-name="Path 8191"
        d="M5,12H19M10,7,5,12m5,5L5,12"
        transform="translate(-5 -7)"
        fill="none"
        :stroke="clr ? clr : '#bbb'"
        stroke-linecap="round"
        stroke-linejoin="round"
        stroke-width="2"
      />
    </g>
    <path id="Path_8192" data-name="Path 8192" d="M0,0H24V24H0Z" fill="none" />
  </svg>
</template>
